/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
// export const SEARCH_ASSET = 'SEARCH_ASSET';
// export const SET_ADDRESS = 'SET_ADDRESS'
// export const GET_ASSET_FROM_RETS = 'GET_ASSET_FROM_RETS'
// export const SUCCESS_GET_ASSET_FROM_RETS = 'SUCCESS_GET_ASSET_FROM_RETS'
// export const FAILURE_GET_ASSET_FROM_RETS = ' FAILURE_GET_ASSET_FROM_RETS'
export const SAVE_ASSET = "SAVE_ASSET";
export const SUCCESS_SAVE_ASSET = "SUCCESS_SAVE_ASSET";
export const FAILURE_SAVE_ASSET = "FAILURE_SAVE_ASSET";

export const ASSET_LIST_REQUEST = "ASSET_LIST_REQUEST";
export const ASSET_LIST_SUCCESS = "ASSET_LIST_SUCCESS";
export const ASSET_LIST_FAILURE = "ASSET_LIST_FAILURE";

export const ASSET_DETAIL_REQUEST = "ASSET_DETAIL_REQUEST";
export const ASSET_DETAIL_SUCCESS = "ASSET_DETAIL_SUCCESS";
export const ASSET_DETAIL_FAILURE = "ASSET_DETAIL_FAILURE";

// export const SAVE_RENT_TO_ASSET = 'SAVE_RENT_TO_ASSET'
// export const SAVE_RENT_TO_ASSET_SUCCESS = 'SAVE_RENT_TO_ASSET_SUCCESS'
// export const SAVE_RENT_TO_ASSET_FAILURE = 'SAVE_RENT_TO_ASSET_FAILURE'

// export const UPDATE_RENT_TO_ASSET = 'UPDATE_RENT_TO_ASSET'
// export const UPDATE_RENT_TO_ASSET_SUCCESS = 'UPDATE_RENT_TO_ASSET_SUCCESS'
// export const UPDATE_RENT_TO_ASSET_FAILURE = 'UPDATE_RENT_TO_ASSET_FAILURE'

// export const SAVE_INSURANCE_TO_ASSET = 'SAVE_INSURANCE_TO_ASSET'
// export const SAVE_INSURANCE_TO_ASSET_SUCCESS = 'SAVE_INSURANCE_TO_ASSET_SUCCESS'
// export const SAVE_INSURANCE_TO_ASSET_FAILURE = 'SAVE_INSURANCE_TO_ASSET_FAILURE'

// export const GET_INSURANCE_FROM_ASSET = 'GET_INSURANCE_FROM_ASSET'
// export const GET_INSURANCE_FROM_ASSET_SUCCESS = 'GET_INSURANCE_FROM_ASSET_SUCCESS'
// export const GET_INSURANCE_FROM_ASSET_FAILURE = 'GET_INSURANCE_FROM_ASSET_FAILURE'

//delte rent
// export const DELETE_RENT_FROM_ASSET = 'DELETE_RENT_FROM_ASSET'
// export const DELETE_RENT_FROM_ASSET_SUCCESS = 'DELETE_RENT_FROM_ASSET_SUCCESS'
// export const DELETE_RENT_FROM_ASSET_FAILURE = 'DELETE_RENT_FROM_ASSET_FAILURE'
// export const FETCH_ASSET_DETAILS = 'FETCH_ASSET_DETAILS';

export const GET_DASHBOARD_OVERVIEW = "GET_DASHBOARD_OVERVIEW";
export const GET_DASHBOARD_OVERVIEW_SUCCESS = "GET_DASHBOARD_OVERVIEW_SUCCESS";

// export const RENT_DETAIL_REQUEST = 'RENT_DETAIL_REQUEST';
// export const RENT_DETAIL_SUCCESS = 'RENT_DETAIL_SUCCESS';
// export const RENT_DETAIL_FAILURE = 'RENT_DETAIL_FAILURE';

// export const UPDATE_ASSET_DETAILS = 'UPDATE_ASSET_DETAILS';
// export const UPDATE_ASSET_DETAILS_SUCCESS = 'UPDATE_ASSET_DETAILS_SUCCESS';
// export const UPDATE_ASSET_DETAILS_FAILURE = 'UPDATE_ASSET_DETAILS_FAILURE';

// export const UPDATE_ASSET_DETAILS_STATE = 'UPDATE_ASSET_DETAILS_STATE';

// export const TOGGLE_EDIT_ASSET_MODAL = 'TOGGLE_EDIT_ASSET_MODAL';
// export const TOGGLE_DELETE_ASSET_MODAL = 'TOGGLE_DELETE_ASSET_MODAL';
// export const TOGGLE_UPDATE_ASSET_INVEST_MODAL = 'TOGGLE_UPDATE_ASSET_INVEST_MODAL';

// export const UPDATE_ASSET_INVEST_DETAILS = 'UPDATE_ASSET_INVEST_DETAILS';
// export const UPDATE_ASSET_INVEST_DETAILS_SUCCESS = 'UPDATE_ASSET_INVEST_DETAILS_SUCCESS';
// export const UPDATE_ASSET_INVEST_DETAILS_FAILURE = 'UPDATE_ASSET_INVEST_DETAILS_FAILURE';
// export const UPDATE_ASSET_INVEST_DETAILS_STATE = 'UPDATE_ASSET_INVEST_DETAILS_STATE';

export const DELETE_ASSET = "DELETE_ASSET";
export const DELETE_ASSET_SUCCESS = "DELETE_ASSET_SUCCESS";
export const DELETE_ASSET_FAILURE = "DELETE_ASSET_FAILURE";
export const RESET_ASSET_DELETE = "RESET_ASSET_DELETE";

export const RESET_BASIC_INFO = "RESET_BASIC_INFO";

// export const ADD_INCOME_TO_ASSET = 'ADD_INCOME_TO_ASSET';
// export const ADD_INCOME_TO_ASSET_SUCCESS = 'ADD_INCOME_TO_ASSET_SUCCESS';
// export const ADD_INCOME_TO_ASSET_FAILURE = 'ADD_INCOME_TO_ASSET_FAILURE';

// export const ADD_FINANCIAL_TO_ASSET = 'ADD_FINANCIAL_TO_ASSET';
// export const ADD_FINANCIAL_TO_ASSET_SUCCESS = 'ADD_FINANCIAL_TO_ASSET_SUCCESS';
// export const ADD_FINANCIAL_TO_ASSET_FAILURE = 'ADD_FINANCIAL_TO_ASSET_FAILURE';

export const LOOKUP_ASSET = "LOOKUP_ASSET";
export const LOOKUP_ASSET_SUCCESS = "LOOKUP_ASSET_SUCCESS";
export const LOOKUP_ASSET_FAILURE = " LOOKUP_ASSET_FAILURE";

export const HAS_ASSET = "HAS_ASSET";
export const HAS_ASSET_SUCCESS = "HAS_ASSET_SUCCESS";
export const HAS_ASSET_FAILURE = "HAS_ASSET_FAILURE";

export const RESET_ASSET_LIST = "RESET_ASSET_LIST";

export const SAVE_ASSET_NOT_FOUND_LOG = "SAVE_ASSET_NOT_FOUND_LOG";

export const BULK_ADD_ASSET = "BULK_ADD_ASSET";
export const BULK_ADD_ASSET_SUCCESS = "BULK_ADD_ASSET_SUCCESS";
export const BULK_ADD_ASSET_FAILURE = "BULK_ADD_ASSET_FAILURE";

export const BULK_ADD_CLIENT = "BULK_ADD_CLIENT";
export const BULK_ADD_CLIENT_SUCCESS = "BULK_ADD_CLIENT_SUCCESS";
export const BULK_ADD_CLIENT_FAILURE = "BULK_ADD_CLIENT_FAILURE";

export const DOWNLOAD_BULK_ADD_CSV = "DOWNLOAD_BULK_ADD_CSV";
export const DOWNLOAD_ASSETS_BULK_ADD_CSV = "DOWNLOAD_ASSETS_BULK_ADD_CSV";

export const LOOKUP_PARCEL = "LOOKUP_PARCEL";
export const LOOKUP_PARCEL_SUCCESS = "LOOKUP_PARCEL_SUCCESS";
export const LOOKUP_PARCEL_FAILURE = "LOOKUP_PARCEL_FAILURE";

export const ADD_ASSET_AND_FINANCIALS = "ADD_ASSET_AND_FINANCIALS";
export const ADD_ASSET_AND_FINANCIALS_SUCCESS =
  "ADD_ASSET_AND_FINANCIALS_SUCCESS";
export const ADD_ASSET_AND_FINANCIALS_FAILURE =
  "ADD_ASSET_AND_FINANCIALS_FAILURE";

export const RESET_ADD_ASSET = "RESET_ADD_ASSET";

export const ADD_ENTITY = "ADD_ENTITY";
export const ADD_ENTITY_SUCCESS = "ADD_ENTITY_SUCCESS";
export const ADD_ENTITY_FAILURE = "ADD_ENTITY_FAILURE";

export const GET_ENTITIES = "GET_ENTITIES";
export const GET_ENTITIES_SUCCESS = "GET_ENTITIES_SUCCESS";
export const GET_ENTITIES_FAILURE = "GET_ENTITIES_FAILURE";
